import { replaceUuidsWithIRIs } from '@/api/axiosHelper';
import { Event } from '@/types/event';

import { API_ROUTES } from '../apiRoutes';
import { axiosPost } from '../axiosService';

interface ActivateDiscountPayload {
  place: string;
  code: string;
}
interface ActivateDiscountProps {
  payload: ActivateDiscountPayload;
}

export const activateDiscount = async ({
  payload,
}: ActivateDiscountProps): Promise<Event[]> => {
  return axiosPost<ActivateDiscountPayload>({
    url: API_ROUTES.activateDiscountUrl(),
    payload: replaceUuidsWithIRIs({ ...payload }) as any,
    isPublic: false,
  });
};
